import i18n from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';

import { initReactI18next } from 'react-i18next';
import { BASE_BOOKIPI_WEB_URL } from 'src/config';

function localResource(language, namespace) {
  return require(`src/assets/translations/${language}/${namespace}.json`);
}

i18n
  .use(initReactI18next)
  .use(ChainedBackend)
  .init({
    backend: {
      backends: [HttpBackend, resourcesToBackend(localResource)],
      backendOptions: [{ loadPath: `${BASE_BOOKIPI_WEB_URL}/translations/{{lng}}/{{ns}}.json` }]
    },
    debug: false,
    defaultNS: 'subscription',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    lng: 'en',
    ns: ['subscription', 'common'],
    preload: ['en'],
    react: {
      useSuspense: false,
      wait: true
    }
  });

export default i18n;
